import { memo } from 'react';
import Router from 'next/router';
import { useReduxState } from 'hooks';
import api from 'api';
import { ConfirmButton } from 'components/common';
import { useEditorDispatch } from 'components/editor';

import type { EditorHeaderStateProps } from './EditorHeader';

type Props = Pick<EditorHeaderStateProps, 'chapters' | 'currentChapter'>;

const EditorHeaderDelete = ({ chapters, currentChapter }: Props) => {
  const {
    messages,
    pageState: { course }
  } = useReduxState();

  const editorDispatch = useEditorDispatch();

  const handleDelete = async () => {
    await api.delete(
      `/admin/courses/${course.id}/chapters/${currentChapter.id}`
    );

    // get chapter we should redirect to, if one exists
    let href = '/admin/courses/[courseSlug]/edit';
    let as = `/admin/courses/${course.slug}/edit`;
    if (chapters.length > 1) {
      const index =
        currentChapter.number < chapters.length
          ? currentChapter.number
          : currentChapter.number - 2;
      href += '/[chapterSlug]';
      as += `/${chapters[index].slug}`;
    }

    const updatedChapters = await api.get(
      `/admin/courses/${course.id}/chapters`
    );
    editorDispatch({
      type: 'updateContext',
      update: { editorChapters: updatedChapters.data.chapters }
    });

    Router.push(href, as);
    return true;
  };

  return (
    <ConfirmButton
      actionText={messages.commonDelete}
      buttonIcon="trash-alt"
      buttonIsDropdown={true}
      buttonText={messages.editDeleteChapter}
      category="danger"
      confirmText={`${
        Object.keys(course.languageVersions).length > 0
          ? messages.courseLanguageVersionsDeleteAllWarningChapter + ' '
          : ''
      }${messages.editDeleteChapterConfirm} ${currentChapter.number}. ${
        currentChapter.title
      }?`}
      confirmTitle={messages.editDeleteChapter}
      onConfirm={handleDelete}
      successMessage={messages.editChapterDeleted}
    />
  );
};

export default memo(EditorHeaderDelete);
